import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import axios from 'axios';
import Popup from '../../../components/Popup';
import ConfirmChequeSettingDelete from './ConfirmChequeSettingDelete'
import EditChequeSetting from './EditChequeSetting'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { chequeSettingsState } from '../recoil/atoms'
import { filteredChequeSettingsState } from '../recoil/selectors'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

const ChequeSetting = props => {
    const { chequeSetting, number } = props;
    const classes = useRowStyles();
    const [deleteChequeSettingPopup, setDeleteChequeSettingPopup] = useState(false)
    const [editChequeSettingPopup, setEditChequeSettingPopup] = useState(false)
    return (
        <>
            <Popup
                title={"آیا از حذف چک " + chequeSetting.title + " مطمئن هستید؟"}
                openPopup={deleteChequeSettingPopup}
                setOpenPopup={setDeleteChequeSettingPopup}
            >
                <ConfirmChequeSettingDelete id={chequeSetting.id} setPopup={setDeleteChequeSettingPopup} />
            </Popup>
            <Popup
                title='ویرایش'
                openPopup={editChequeSettingPopup}
                setOpenPopup={setEditChequeSettingPopup}
            >
                <EditChequeSetting id={chequeSetting.id} setPopup={setEditChequeSettingPopup} />
            </Popup>
            <TableRow className={classes.root}>
                <TableCell component="th" scope="row">
                    {number}
                </TableCell>
                <TableCell component="th" scope="row">
                    {chequeSetting.title}
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => setEditChequeSettingPopup(true)} size="small">
                        <EditIcon />
                    </IconButton>
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => setDeleteChequeSettingPopup(true)} size="small">
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        </>
    );
}




const ChequeSettingsTable = () => {
    const filteredChequeSettings = useRecoilValue(filteredChequeSettingsState)
    const setChequeSettings = useSetRecoilState(chequeSettingsState)
    // Get cheque settings
    const getChequeSettingsData = async () => {
        const data = await axios.get('accounts/cheque_setting/').then(result => result.data)
        setChequeSettings(data)
    }
    useEffect(() => {
        getChequeSettingsData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <TableContainer component={Paper}>
            <Table aria-label="banks">
                <TableHead>
                    <TableRow>
                        <TableCell>ردیف</TableCell>
                        <TableCell>عنوان چک</TableCell>
                        <TableCell align="right">
                            ویرایش
                        </TableCell>
                        <TableCell align="right">
                            حذف
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredChequeSettings.map((chequeSetting, key) => (
                        <ChequeSetting key={key} number={key + 1} chequeSetting={chequeSetting} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default ChequeSettingsTable